import {create} from 'jss'
import preset from 'jss-preset-default'
import {SmartPlugin} from '../smart'

export class JssScript {
    constructor(jss){
        this.$stylesheet = null;
        this.$jss = jss;
        this.$data = null;
    }

    rebuild() {
        this.clear();

        if(!this.$data || Object.keys(this.$data).length == 0){
            return;
        }

        var jss = this.$jss;
        this.$stylesheet = jss.createStyleSheet(this.$data);
        this.$stylesheet.attach();
    }

    clear() {
        if (this.$stylesheet)
            this.$stylesheet.detach();
        this.$stylesheet = null;
    }
}


export class SmartJss extends SmartPlugin{
    constructor(props){
        super('smart-jss', props);
        this.$jss = create();
        this.$jss.setup(preset())
        this.$jss.setup({
            createGenerateClassName() {
                return (rule) => rule.key;
            }
        });
    }
}